( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'dual-image-content-grid', COMPONENT );
} )( app );
